import React from 'react';
import {ControlButton, TscButtonType, TscStyles, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import styled from 'styled-components';
import {useTscTheme} from '../../context/themeProvider';
import {useTranslation} from 'react-i18next';

const TeamInfoMessageWrapper = styled.div`
   position: relative;
   display: flex;
   align-items: center;
   border-radius: ${TscStyles.border.radius.xl};
   border: 1px solid ${(props: {borderColor: string}) => props.borderColor || TscStyles.color.message.caution};
   background: rgba(235, 174, 33, 0.1);
   padding: 0.5rem;
   box-sizing: border-box;
   font-weight: ${TscStyles.font.weight.semibold};
   font-size: 0.75rem;
   justify-content: space-between;

   .teams-action-button {
      background: linear-gradient(to right, ${TscStyles.color.action.screencastPrimaryStop1}, ${TscStyles.color.action.screencastPrimaryStop2});
      margin-left: 0.25rem;
   }
`;

const CloseGlyph = styled(ControlButton)`
   position: absolute;
   right: 0;
`;

const QuotasPromptWrapper = styled.span`
   font-size: 0.75rem;
   font-weight: ${TscStyles.font.weight.semibold};
`;

export const InfoType = {
   Info: TscStyles.color.message.info,
   Warning: TscStyles.color.message.caution,
   Error: TscStyles.color.message.warning
};

export const TeamInfoMessageContainer: React.FC<ITeamInfoMessageContainerProps> = ({infoType, promptText, showCloseGlyph, onCloseGlyphClick, hideButton, buttonLabel, buttonAction}) => {
   const theme = useTscTheme();
   const {t} = useTranslation();

   return (
      <TeamInfoMessageWrapper borderColor={infoType}>
         {showCloseGlyph && onCloseGlyphClick && (
            <CloseGlyph
               buttonType={TscButtonType.tertiary}
               themeName={theme}
               title={t('general.close')}
               glyph={<Glyphs.Close16x16 />}
               testId="team-info-close-button"
               onClick={onCloseGlyphClick}
            />
         )}
         <QuotasPromptWrapper>
            {promptText}
         </QuotasPromptWrapper>
         {!hideButton && (
            <ControlButton
               buttonType={TscButtonType.secondary}
               label={buttonLabel}
               className="teams-action-button"
               onClick={buttonAction ? () => buttonAction() : null}
            />
         )}
      </TeamInfoMessageWrapper>
   );
};

export interface ITeamInfoMessageContainerProps {
   infoType: string;
   promptText: string;
   showCloseGlyph?: boolean;
   onCloseGlyphClick?(): void;
   hideButton?: boolean;
   buttonLabel?: string;
   buttonAction?(): void;
}